 import React from 'react'
import Navbar from './Navbar'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'
 
 const NavFoot = () => {
   return (
    <div>
    <div className="">
      <Navbar />
    </div>
    <div className=" mt-12 ">
      <Outlet />
    </div>
    <div className="">
      <Footer />
    </div>
  </div>
   )
 }
 
 export default NavFoot